<template>
	<section class="feedback-section">
		<div class="form-section">
			<div class="info">
				<UIShIcon name="chat" class="icon" />

				<h4>Бесплатная консультация</h4>
				<p>
					Ответим на все ваши вопросы и подготовим коммерческое
					предложение с указанием цен и сроками доставки
				</p>
			</div>
			<FeedbackForm class="form" />
		</div>

		<div class="container">
			<NuxtImg
				width="567"
				height="485"
				src="/images/container-black.png"
				class="image"
				loading="lazy"
				format="webp"
				alt="container"
				decoding="async"
				sizes="sm:60vw xl:100vw"
			/>
		</div>
	</section>
</template>

<script setup lang="ts">
import FeedbackForm from '@/components/FeedbackForm.vue';
</script>

<style lang="scss" scoped>
.feedback-section {
	margin-top: 4.444rem;
}

.form-section {
	left: calc(var(--layout-pad-x) * -1);
	width: calc(100% + var(--layout-pad-x) * 2);
	padding: 0.667rem;
	border-radius: 1.111rem;
	background-color: var(--color-brand500);
	color: var(--color-white);
	position: relative;
	overflow: hidden;

	&::before {
		content: '';
		position: absolute;
		width: 100%;
		height: 62.93%;
		opacity: 0.05;
		top: -22.72%;
		left: -35%;
		transform: rotate(-8.23deg);
		background-color: var(--color-white);
	}
}

.info {
	@include useFont(tmdm);

	h4 {
		margin-top: 0.889rem;
		@include useFont(dxsb);
		text-transform: uppercase;
	}

	.icon {
		display: none;
	}

	p {
		margin-top: 0.444rem;
		max-width: 18.167rem;
	}
}

.form {
	margin-top: 1.778rem;
}

.container {
	margin-top: 0.667rem;
	border-radius: 1.111rem;
	background-color: var(--color-gray900);
	position: relative;
	overflow: hidden;
	display: flex;
	justify-content: end;

	&:after {
		content: '';
		position: absolute;
		background-color: var(--color-gray800);
		transform: rotate(-44.67deg);
		width: 113.39%;
		height: 113.74%;
		left: 25.29%;
		top: -31.61%;
	}

	.image {
		top: -0.389rem;
		padding-left: 1rem;
		padding-bottom: 1.5rem;
		z-index: var(--z-index);
		position: relative;
		height: 17rem;
		max-height: 17rem;
	}
}

@include screen1024 {
	.feedback-section {
		display: grid;
		grid-template-columns: 55% 1fr;
		grid-template-rows: auto;
		column-gap: 1.111rem;
	}

	.form-section {
		width: 100%;
		left: 0;
	}

	.container {
		margin-top: 0;

		.image {
			width: 100%;
			height: 100%;
			max-height: 27rem;
		}
	}
}

@include screen1920 {
	.feedback-section {
		margin-top: 7.778rem;
		display: grid;
		grid-template-columns: minmax(51.111rem, 1fr) minmax(
				16.667rem,
				33.333rem
			);
		grid-template-rows: 28.889rem;
		column-gap: 1.111rem;
	}

	.form-section {
		left: 0;
		width: 100%;
		padding: 2.667rem;
		display: grid;
		align-items: center;
		grid-template-columns: 1fr 30.667rem;
		column-gap: 1.111rem;
		border-radius: 1.333rem;

		&::before {
			width: 32rem;
			height: 32rem;
			opacity: 0.05;
			top: 7rem;
			left: -4rem;
		}
	}

	.info {
		display: flex;
		flex-direction: column;
		justify-content: flex-end;
		gap: 1.333rem;
		@include useFont(dxsm);
		height: 100%;

		h4 {
			margin-top: 0;
			@include useFont(dlgb);
		}

		.icon {
			display: block;
			width: 2.444rem;
			height: 2.444rem;
			margin-bottom: auto;
		}

		p {
			margin-top: 0;
			max-width: 20.278rem;
		}
	}

	.form {
		margin-top: 0;
	}

	.container {
		border-radius: 1.333rem;
		background-color: var(--color-gray900);
		position: relative;
		overflow: hidden;

		&:after {
			content: '';
			position: absolute;
			background-color: var(--color-gray800);
			transform: rotate(315deg);
			width: 27.778rem;
			height: 40.778rem;
			left: 12.722rem;
			top: -10.222rem;
		}

		.image {
			max-height: 100%;
			padding-left: 1.833rem;
			padding-bottom: 1.944rem;
			z-index: var(--z-index);
			position: relative;
		}
	}
}
</style>
